import { ContentPage, contentMeta, type ContentPageData } from '@/site/content'
import { INDUSTRY_PAGES } from '@/site/industries'

const page: ContentPageData = {
  path: '/dlya',
  crumb: 'Галузі',
  title: 'AI-адміністратор для вашого бізнесу: галузі | Anytel',
  description:
    'Як AI-агент Anytel працює в клініках, автосервісах, ресторанах, агенціях нерухомості й салонах краси: приклади розмов і що він робить у кожній галузі.',
  eyebrow: 'Галузі',
  h1: 'AI-адміністратор для вашої галузі',
  lead:
    'Агент говорить мовою вашого бізнесу: знає послуги, ціни і графік, записує клієнтів і передає заявки. Оберіть свою галузь, щоб побачити приклад розмови і як усе налаштовується.',
  cards: INDUSTRY_PAGES,
  sections: [
    {
      h2: 'Не знайшли свою галузь?',
      blocks: [
        'Агент підходить будь-якому бізнесу, де клієнти телефонують, щоб записатися, щось замовити чи дізнатися ціну: ремонт техніки, ветеринарні клініки, освітні центри, служби прибирання, юридичні й бухгалтерські послуги. Ви описуєте свої послуги й правила звичайним текстом, а сценарій дзвінка збираєте з готових кроків.',
        'Подивіться, [що вміє агент](/funktsii), або залиште заявку на [безкоштовний пілот](/#pilot): налаштуємо перший сценарій разом.',
      ],
    },
  ],
}

export const meta = contentMeta(page)

export default function Page() {
  return <ContentPage page={page} />
}
